/**
 * Personalizer return flow: when the external personalizer redirects back to
 * the PDP with query params, add the matching variant to cart with file props.
 *
 * Query params: file-token, variant-medium, variant-base-size,
 *               thumbnail-url (optional), edit-url (optional)
 */
(function () {
  function parseVariants() {
    const el = document.querySelector('[data-og-personaliser-variants]');
    if (el) {
      try {
        const parsed = JSON.parse(el.textContent);
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {
        /* fall through */
      }
    }

    try {
      const variants =
        window.ShopifyAnalytics &&
        ShopifyAnalytics.meta &&
        ShopifyAnalytics.meta.product &&
        ShopifyAnalytics.meta.product.variants;
      return Array.isArray(variants) ? variants : [];
    } catch (e) {
      return [];
    }
  }

  function findVariantId(variants, medium, baseSize) {
    const mediumLower = String(medium).toLowerCase();
    const sizeLower = String(baseSize).toLowerCase();

    for (let i = 0; i < variants.length; i += 1) {
      const variant = variants[i];
      const options = (variant.options || []).map(function (o) {
        return String(o).toLowerCase();
      });
      const title = String(variant.title || variant.name || '').toLowerCase();
      const hasMedium =
        options.some(function (o) {
          return o === mediumLower || o.indexOf(mediumLower) !== -1;
        }) || title.indexOf(mediumLower) !== -1;
      const hasSize =
        options.some(function (o) {
          return o === sizeLower || o.indexOf(sizeLower) !== -1;
        }) || title.indexOf(sizeLower) !== -1;
      if (hasMedium && hasSize) return variant.id;
    }
    return null;
  }

  function fulfillmentForMedium(medium) {
    const value = String(medium || '').toLowerCase();
    if (value === 'digital') return 'digital';
    if (value === 'physical') return 'physical';
    return '';
  }

  function addToCart(variantId, properties) {
    return fetch(window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: properties,
      }),
    }).then(function (response) {
      if (!response.ok) throw new Error('add failed');
      return response.json();
    });
  }

  function fetchCart() {
    return fetch(window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root + 'cart.js'
      : '/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) throw new Error('cart failed');
      return response.json();
    });
  }

  function notifyCartUpdated(cart) {
    window.dispatchEvent(
      new CustomEvent('cartcount:update', {
        detail: cart,
      })
    );
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: cart,
      })
    );

    const cartButton = document.querySelector('.site-header-cart--button');
    if (cartButton) {
      cartButton.click();
    }
  }

  function cleanUrl() {
    try {
      const url = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, url);
    } catch (e) {
      /* ignore */
    }
  }

  function run() {
    const params = new URLSearchParams(window.location.search);
    const fileToken = params.get('file-token');
    const medium = params.get('variant-medium');
    const baseSize = params.get('variant-base-size');
    const thumbnailUrl = params.get('thumbnail-url');
    const editUrl = params.get('edit-url');

    if (!fileToken || !medium || !baseSize) return;

    const variants = parseVariants();
    const variantId = findVariantId(variants, medium, baseSize);
    if (!variantId) {
      console.error('[only-games] No personalizer variant for', medium, baseSize);
      return;
    }

    const properties = {
      _fileToken: fileToken,
    };
    if (thumbnailUrl) properties._thumbnailUrl = thumbnailUrl;
    if (editUrl) properties._editUrl = editUrl;

    const fulfillment = fulfillmentForMedium(medium);
    if (fulfillment) {
      properties['_Fulfillment Type'] = fulfillment;
    }

    addToCart(variantId, properties)
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        cleanUrl();
        notifyCartUpdated(cart);
      })
      .catch(function (err) {
        console.error('[only-games] Personalizer cart add failed', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
